export default class HistoryAction {
    constructor(key, color, message) {
        this.key = key;
        this.color = color;
        this.message = message
    }
}